var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoldOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 362.896,
    height: 206.374,
    viewBox: "0 0 362.896 206.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12373",
    "data-name": "Group 12373",
    transform: "translate(-49.333 -70.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12320",
    "data-name": "Group 12320",
    transform: "translate(98.622 78.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12313",
    "data-name": "Group 12313",
    transform: "translate(27.336 18.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9633",
    "data-name": "Path 9633",
    d: "M232.94,143.226v-5.7a1.009,1.009,0,0,0-1.01-1.01h-1.468a.926.926,0,0,1-.906-.711,20.174,20.174,0,0,0-2.541-6.165.941.941,0,0,1,.123-1.167l1.032-1.032a1.01,1.01,0,0,0,0-1.429l-4.032-4.032a1.01,1.01,0,0,0-1.428,0l-1.031,1.031a.94.94,0,0,1-1.167.122,20.192,20.192,0,0,0-6.167-2.543.926.926,0,0,1-.711-.906v-1.463a1.01,1.01,0,0,0-1.01-1.01h-5.7a1.01,1.01,0,0,0-1.01,1.01v1.463a.926.926,0,0,1-.711.906,20.18,20.18,0,0,0-6.168,2.543.94.94,0,0,1-1.167-.123l-1.03-1.03a1.01,1.01,0,0,0-1.428,0l-4.032,4.032a1.01,1.01,0,0,0,0,1.429l1.031,1.031a.94.94,0,0,1,.122,1.167,20.212,20.212,0,0,0-2.541,6.167.926.926,0,0,1-.906.711h-1.466a1.01,1.01,0,0,0-1.01,1.01v5.7a1.01,1.01,0,0,0,1.01,1.01h1.467a.926.926,0,0,1,.906.711,20.2,20.2,0,0,0,2.542,6.165.94.94,0,0,1-.122,1.167l-1.032,1.033a1.01,1.01,0,0,0,0,1.428l4.032,4.033a1.01,1.01,0,0,0,1.428,0l1.033-1.034a.941.941,0,0,1,1.167-.122,20.194,20.194,0,0,0,6.164,2.538.926.926,0,0,1,.711.906v1.471a1.01,1.01,0,0,0,1.01,1.01h5.7a1.01,1.01,0,0,0,1.01-1.01v-1.471a.927.927,0,0,1,.711-.906,20.187,20.187,0,0,0,6.164-2.538.94.94,0,0,1,1.167.122l1.034,1.034a1.01,1.01,0,0,0,1.428,0l4.032-4.033a1.01,1.01,0,0,0,0-1.428l-1.033-1.033a.941.941,0,0,1-.123-1.167,20.172,20.172,0,0,0,2.541-6.164.926.926,0,0,1,.906-.711h1.469A1.01,1.01,0,0,0,232.94,143.226Zm-23.169,13.228a16.077,16.077,0,1,1,16.07-16.084A16.075,16.075,0,0,1,209.771,156.454Z",
    transform: "translate(-186.604 -117.207)",
    fill: "none",
    stroke: "#ffecdc",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9634",
    "data-name": "Path 9634",
    d: "M291.848,184.53v-3.886a.688.688,0,0,0-.688-.688h-1a.631.631,0,0,1-.618-.485,13.757,13.757,0,0,0-1.731-4.2.64.64,0,0,1,.083-.8l.7-.7a.689.689,0,0,0,0-.974l-2.748-2.748a.688.688,0,0,0-.973,0l-.7.7a.642.642,0,0,1-.8.083,13.748,13.748,0,0,0-4.2-1.733.632.632,0,0,1-.485-.618v-1A.688.688,0,0,0,278,166.8h-3.886a.688.688,0,0,0-.688.688v1a.632.632,0,0,1-.485.618,13.761,13.761,0,0,0-4.2,1.733.642.642,0,0,1-.8-.083l-.7-.7a.688.688,0,0,0-.974,0l-2.747,2.748a.689.689,0,0,0,0,.974l.7.7a.641.641,0,0,1,.083.8,13.753,13.753,0,0,0-1.732,4.2.631.631,0,0,1-.618.484h-1a.688.688,0,0,0-.688.688v3.886a.689.689,0,0,0,.688.689h1a.631.631,0,0,1,.617.484,13.777,13.777,0,0,0,1.732,4.2.641.641,0,0,1-.083.8l-.7.7a.689.689,0,0,0,0,.974l2.747,2.748a.689.689,0,0,0,.974,0l.7-.7a.64.64,0,0,1,.8-.083,13.77,13.77,0,0,0,4.2,1.73.631.631,0,0,1,.485.618v1a.688.688,0,0,0,.688.688H278a.688.688,0,0,0,.688-.688v-1a.631.631,0,0,1,.485-.617,13.775,13.775,0,0,0,4.2-1.73.641.641,0,0,1,.8.083l.7.7a.688.688,0,0,0,.973,0l2.748-2.748a.689.689,0,0,0,0-.974l-.7-.7a.642.642,0,0,1-.083-.8,13.759,13.759,0,0,0,1.732-4.2.631.631,0,0,1,.618-.484h1A.688.688,0,0,0,291.848,184.53Zm-15.789,8.4a10.339,10.339,0,1,1,10.334-10.343A10.337,10.337,0,0,1,276.059,192.927Z",
    transform: "translate(-219.283 -139.206)",
    fill: "#ffead8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12314",
    "data-name": "Group 12314",
    transform: "translate(5.591 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 1.884,
    cy: 1.884,
    r: 1.884,
    transform: "translate(19.242 162.497)",
    fill: "#ffca9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 1.884,
    cy: 1.884,
    r: 1.884,
    transform: "translate(271.641 111.018)",
    fill: "#ffca9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_434",
    "data-name": "Ellipse 434",
    cx: 1.884,
    cy: 1.884,
    r: 1.884,
    transform: "translate(267.873 43.745)",
    fill: "#ffca9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_435",
    "data-name": "Ellipse 435",
    cx: 1.182,
    cy: 1.182,
    r: 1.182,
    transform: "translate(200.837 21.582)",
    fill: "#ffcb9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9635",
    "data-name": "Path 9635",
    d: "M196.862,96.468a1.182,1.182,0,1,1-1.182-1.182A1.182,1.182,0,0,1,196.862,96.468Z",
    transform: "translate(-168.361 -89.447)",
    fill: "#ffc797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9636",
    "data-name": "Path 9636",
    d: "M243.872,227.264a1.182,1.182,0,1,1-1.182-1.182A1.182,1.182,0,0,1,243.872,227.264Z",
    transform: "translate(-189.214 -147.468)",
    fill: "#ffd0a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9637",
    "data-name": "Path 9637",
    d: "M165.951,382.673a1.182,1.182,0,1,1-1.182-1.181A1.181,1.181,0,0,1,165.951,382.673Z",
    transform: "translate(-154.648 -216.408)",
    fill: "#ffcb9f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_436",
    "data-name": "Ellipse 436",
    cx: 1.884,
    cy: 1.884,
    r: 1.884,
    transform: "translate(244.005 163.61)",
    fill: "#ffca9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_437",
    "data-name": "Ellipse 437",
    cx: 1.884,
    cy: 1.884,
    r: 1.884,
    transform: "translate(284.065 163.61)",
    fill: "#ffca9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_438",
    "data-name": "Ellipse 438",
    cx: 1.884,
    cy: 1.884,
    r: 1.884,
    transform: "translate(59.099)",
    fill: "#ffcb9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9638",
    "data-name": "Path 9638",
    d: "M486.731,240.226a2.521,2.521,0,1,1-2.521-2.521A2.521,2.521,0,0,1,486.731,240.226Z",
    transform: "translate(-295.759 -152.624)",
    fill: "#ffc99b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9639",
    "data-name": "Path 9639",
    d: "M152.564,184.2a2.521,2.521,0,1,1-2.52-2.52A2.521,2.521,0,0,1,152.564,184.2Z",
    transform: "translate(-147.522 -127.771)",
    fill: "#ffc99b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12315",
    "data-name": "Group 12315",
    transform: "translate(0 14.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4162",
    "data-name": "Rectangle 4162",
    width: 3.909,
    height: 3.909,
    rx: 0.664,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4163",
    "data-name": "Rectangle 4163",
    width: 3.909,
    height: 3.909,
    rx: 0.664,
    transform: "translate(5.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4164",
    "data-name": "Rectangle 4164",
    width: 3.909,
    height: 3.909,
    rx: 0.664,
    transform: "translate(10.458)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12317",
    "data-name": "Group 12317",
    transform: "translate(266.281 152.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12316",
    "data-name": "Group 12316",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4165",
    "data-name": "Rectangle 4165",
    width: 3.909,
    height: 3.909,
    rx: 0.664,
    fill: "#ffebdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4166",
    "data-name": "Rectangle 4166",
    width: 3.909,
    height: 3.909,
    rx: 0.664,
    transform: "translate(5.229)",
    fill: "#ffebdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4167",
    "data-name": "Rectangle 4167",
    width: 3.909,
    height: 3.909,
    rx: 0.664,
    transform: "translate(10.458)",
    fill: "#ffebdb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12319",
    "data-name": "Group 12319",
    transform: "translate(24.545 150.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12318",
    "data-name": "Group 12318",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4168",
    "data-name": "Rectangle 4168",
    width: 3.909,
    height: 3.909,
    rx: 0.664,
    fill: "#ffe5cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4169",
    "data-name": "Rectangle 4169",
    width: 3.909,
    height: 3.909,
    rx: 0.664,
    transform: "translate(5.229)",
    fill: "#ffe5cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4170",
    "data-name": "Rectangle 4170",
    width: 3.909,
    height: 3.909,
    rx: 0.664,
    transform: "translate(10.458)",
    fill: "#ffe5cf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12329",
    "data-name": "Group 12329",
    transform: "translate(181.261 75.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12321",
    "data-name": "Group 12321"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4171",
    "data-name": "Rectangle 4171",
    width: 99.039,
    height: 191.323,
    rx: 21.349,
    fill: "#253348"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4172",
    "data-name": "Rectangle 4172",
    width: 95.33,
    height: 186.929,
    rx: 18.7,
    transform: "translate(1.854 1.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9640",
    "data-name": "Path 9640",
    d: "M383.817,93.5V259.422a7.046,7.046,0,0,1-7.046,7.046H303.879a7.046,7.046,0,0,1-7.046-7.046V93.5a7.046,7.046,0,0,1,7.046-7.047h12.155a1.782,1.782,0,0,1,1.594.984l1.291,2.577a3.482,3.482,0,0,0,3.122,1.933h36.568a3.482,3.482,0,0,0,3.122-1.933l1.291-2.577a1.782,1.782,0,0,1,1.594-.984h12.155A7.046,7.046,0,0,1,383.817,93.5Z",
    transform: "translate(-290.806 -81.742)",
    fill: "#fef1e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9641",
    "data-name": "Path 9641",
    d: "M378.111,88.929H348.659a1.24,1.24,0,0,1-1.24-1.24h0a1.24,1.24,0,0,1,1.24-1.24h29.452a1.24,1.24,0,0,1,1.24,1.24h0A1.24,1.24,0,0,1,378.111,88.929Z",
    transform: "translate(-313.246 -81.742)",
    fill: "#fcede1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4173",
    "data-name": "Rectangle 4173",
    width: 74.863,
    height: 32.466,
    rx: 8.379,
    transform: "translate(11.239 146.501)",
    fill: "none",
    stroke: "#d29b6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: 2.837
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4174",
    "data-name": "Rectangle 4174",
    width: 39.238,
    height: 22.794,
    rx: 6.044,
    transform: "translate(42.244 76.504)",
    fill: "none",
    stroke: "#d6a071",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: 2.837
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12325",
    "data-name": "Group 12325",
    transform: "translate(11.239 101.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4175",
    "data-name": "Rectangle 4175",
    width: 75.161,
    height: 36.334,
    rx: 7.201,
    transform: "translate(2.725 2.94)",
    fill: "#976b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9642",
    "data-name": "Path 9642",
    d: "M381.063,265v28.337a4,4,0,0,1-4,3.995H310.2a4,4,0,0,1-4-3.995V265a4,4,0,0,1,4-4h66.862A4,4,0,0,1,381.063,265Z",
    transform: "translate(-306.2 -261)",
    fill: "#efa96e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4176",
    "data-name": "Rectangle 4176",
    width: 25.107,
    height: 25.107,
    rx: 4.861,
    transform: "translate(3.459 8.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12322",
    "data-name": "Group 12322",
    transform: "translate(31.005 9.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9643",
    "data-name": "Path 9643",
    d: "M380.126,280.216H362.778a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854h17.348a.854.854,0,0,1,.855.854h0A.854.854,0,0,1,380.126,280.216Z",
    transform: "translate(-361.924 -278.508)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9644",
    "data-name": "Path 9644",
    d: "M372.221,286.346h-9.443a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.855h9.443a.854.854,0,0,1,.854.855h0A.854.854,0,0,1,372.221,286.346Z",
    transform: "translate(-361.924 -281.227)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9645",
    "data-name": "Path 9645",
    d: "M411.546,286.346H386a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.855h25.551a.855.855,0,0,1,.854.855h0A.855.855,0,0,1,411.546,286.346Z",
    transform: "translate(-372.223 -281.227)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9646",
    "data-name": "Path 9646",
    d: "M377.388,292.475h-14.61a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854h14.61a.854.854,0,0,1,.854.854h0A.855.855,0,0,1,377.388,292.475Z",
    transform: "translate(-361.924 -283.946)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9647",
    "data-name": "Path 9647",
    d: "M404,292.475h-9.184a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854H404a.854.854,0,0,1,.854.854h0A.855.855,0,0,1,404,292.475Z",
    transform: "translate(-376.137 -283.946)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9648",
    "data-name": "Path 9648",
    d: "M425.173,292.475h-8.458a.855.855,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854h8.458a.854.854,0,0,1,.854.854h0A.855.855,0,0,1,425.173,292.475Z",
    transform: "translate(-385.851 -283.946)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9649",
    "data-name": "Path 9649",
    d: "M401.247,298.6H362.778a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854h38.469a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,401.247,298.6Z",
    transform: "translate(-361.924 -286.665)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9650",
    "data-name": "Path 9650",
    d: "M383.95,304.733H362.778a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854H383.95a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,383.95,304.733Z",
    transform: "translate(-361.924 -289.384)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9651",
    "data-name": "Path 9651",
    d: "M420.848,304.733H406.964a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854h13.884a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,420.848,304.733Z",
    transform: "translate(-381.525 -289.384)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9652",
    "data-name": "Path 9652",
    d: "M375.217,310.862H362.778a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854h12.439a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,375.217,310.862Z",
    transform: "translate(-361.924 -292.103)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9653",
    "data-name": "Path 9653",
    d: "M403.625,310.862H391.186a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854h12.439a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,403.625,310.862Z",
    transform: "translate(-374.526 -292.103)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9654",
    "data-name": "Path 9654",
    d: "M426.162,310.862h-7.218a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854h7.218a.855.855,0,0,1,.854.854h0A.854.854,0,0,1,426.162,310.862Z",
    transform: "translate(-386.839 -292.103)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9655",
    "data-name": "Path 9655",
    d: "M380.126,316.992H362.778a.854.854,0,0,1-.854-.855h0a.854.854,0,0,1,.854-.854h17.348a.855.855,0,0,1,.855.854h0A.855.855,0,0,1,380.126,316.992Z",
    transform: "translate(-361.924 -294.821)",
    fill: "#ac6121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9656",
    "data-name": "Path 9656",
    d: "M418.086,280.216H400.737a.854.854,0,0,1-.854-.854h0a.854.854,0,0,1,.854-.854h17.349a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,418.086,280.216Z",
    transform: "translate(-378.763 -278.508)",
    fill: "#ac6121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12324",
    "data-name": "Group 12324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9657",
    "data-name": "Path 9657",
    d: "M381.063,265v1.191H306.2V265a4,4,0,0,1,4-4h66.862A4,4,0,0,1,381.063,265Z",
    transform: "translate(-306.2 -261)",
    fill: "#f28f3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12323",
    "data-name": "Group 12323",
    transform: "translate(58.898 1.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9658",
    "data-name": "Path 9658",
    d: "M413.91,265.094a.928.928,0,1,1-.928-.927A.928.928,0,0,1,413.91,265.094Z",
    transform: "translate(-412.055 -264.167)",
    fill: "#fff5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9659",
    "data-name": "Path 9659",
    d: "M422.438,265.094a.928.928,0,1,1-.928-.927A.928.928,0,0,1,422.438,265.094Z",
    transform: "translate(-415.838 -264.167)",
    fill: "#fff5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9660",
    "data-name": "Path 9660",
    d: "M430.966,265.094a.928.928,0,1,1-.928-.927A.928.928,0,0,1,430.966,265.094Z",
    transform: "translate(-419.621 -264.167)",
    fill: "#fff5ec"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12327",
    "data-name": "Group 12327",
    transform: "translate(15.622 76.525)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4177",
    "data-name": "Rectangle 4177",
    width: 22.774,
    height: 22.774,
    rx: 7.151,
    fill: "none",
    stroke: "#ff8a27",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12326",
    "data-name": "Group 12326",
    transform: "translate(4.553 8.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9661",
    "data-name": "Path 9661",
    d: "M325.541,230.071l-3.281,3.281,3.307,3.307",
    transform: "translate(-322.26 -230.071)",
    fill: "none",
    stroke: "#ff8a27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.672
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9662",
    "data-name": "Path 9662",
    d: "M340.906,230.071l3.281,3.281-3.307,3.307",
    transform: "translate(-330.52 -230.071)",
    fill: "none",
    stroke: "#ff8a27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.672
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    x1: 3.073,
    y2: 6.588,
    transform: "translate(5.297)",
    fill: "none",
    stroke: "#ff8a27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.672
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12328",
    "data-name": "Group 12328",
    transform: "translate(11.239 16.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4178",
    "data-name": "Rectangle 4178",
    width: 74.863,
    height: 55.434,
    rx: 8.18,
    fill: "#eb9b58"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_439",
    "data-name": "Ellipse 439",
    cx: 10.85,
    cy: 10.85,
    r: 10.85,
    transform: "translate(48.852 3.789)",
    fill: "#fef2e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9663",
    "data-name": "Path 9663",
    d: "M350.206,172.847H310.751A4.553,4.553,0,0,1,306.2,168.3V161L323.465,131.1a2.345,2.345,0,0,1,4.062,0l13.036,22.579,9.681,16.77A2.3,2.3,0,0,1,350.206,172.847Z",
    transform: "translate(-306.2 -117.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9664",
    "data-name": "Path 9664",
    d: "M385.789,182.7H348.06l11.072-19.174L365.1,153.2a2.11,2.11,0,0,1,3.656,0Z",
    transform: "translate(-324.769 -127.27)",
    fill: "#fff7f1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12339",
    "data-name": "Group 12339",
    transform: "translate(267.787 149.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12331",
    "data-name": "Group 12331",
    transform: "translate(31.483 83.489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4179",
    "data-name": "Rectangle 4179",
    width: 29.087,
    height: 43.712,
    fill: "#a44b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9786",
    "data-name": "Path 9786",
    d: "M0,0H11.137V43.712H0Z",
    transform: "translate(40.224 43.712) rotate(180)",
    fill: "#f28f3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12330",
    "data-name": "Group 12330",
    transform: "translate(30.681 1.679)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4181",
    "data-name": "Rectangle 4181",
    width: 8.177,
    height: 1.395,
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4182",
    "data-name": "Rectangle 4182",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 2.997)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4183",
    "data-name": "Rectangle 4183",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 5.994)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4184",
    "data-name": "Rectangle 4184",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 8.991)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4185",
    "data-name": "Rectangle 4185",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 11.988)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4186",
    "data-name": "Rectangle 4186",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 14.985)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4187",
    "data-name": "Rectangle 4187",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 17.981)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4188",
    "data-name": "Rectangle 4188",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 20.978)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4189",
    "data-name": "Rectangle 4189",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 23.975)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4190",
    "data-name": "Rectangle 4190",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 26.972)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4191",
    "data-name": "Rectangle 4191",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 29.969)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4192",
    "data-name": "Rectangle 4192",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 32.966)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4193",
    "data-name": "Rectangle 4193",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 35.963)",
    fill: "#ffcfa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4194",
    "data-name": "Rectangle 4194",
    width: 8.177,
    height: 1.395,
    transform: "translate(0 38.96)",
    fill: "#ffcfa7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12338",
    "data-name": "Group 12338",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9665",
    "data-name": "Path 9665",
    d: "M489.585,435.664h14.782a8.064,8.064,0,0,0-.964-5.893s-1.19.954-4.754.309a15.852,15.852,0,0,1-2.514,1.757C495.1,432.336,489.186,433.5,489.585,435.664Z",
    transform: "translate(-462.827 -308.464)",
    fill: "#281616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9666",
    "data-name": "Path 9666",
    d: "M491.185,363.06c.955,5.7,5.36,24.971,7.254,36.357a17.375,17.375,0,0,0,6-.305c-.172-3.97-.514-13.468-.474-17.633.066-7.039.4-16.321-2.7-21.415l-10.419.82c.063.55.121,1,.172,1.318S491.127,362.791,491.185,363.06Z",
    transform: "translate(-463.396 -277.541)",
    fill: "#4d2300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9667",
    "data-name": "Path 9667",
    d: "M441.529,435.664h14.783a8.064,8.064,0,0,0-.964-5.893s-1.19.954-4.754.309a15.867,15.867,0,0,1-2.515,1.757C447.046,432.336,441.13,433.5,441.529,435.664Z",
    transform: "translate(-441.509 -308.464)",
    fill: "#281616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9668",
    "data-name": "Path 9668",
    d: "M457.066,396.353a16.959,16.959,0,0,0,5.839.522c.786-4.577,2.028-14.647,3.145-19.367,1.734-7.337,3.431-17.428,2.252-21.027l-10.249-2.574C458.019,354.231,457.185,385.113,457.066,396.353Z",
    transform: "translate(-448.41 -274.81)",
    fill: "#291606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9669",
    "data-name": "Path 9669",
    d: "M498.623,332.231h0c-.206-2.025-.443-3.5-.443-3.5l-11.451,2.8L477,333.745c-3.606.8-7.962,1.77-11.8,2.638-4.309.979-7.17,4.253-6.226,8.568l1.08,5.234c6.027-.082,34.366-2.8,36.79-4.023C499.582,344.779,500.406,339.89,498.623,332.231Z",
    transform: "translate(-449.176 -263.64)",
    fill: "#291606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9670",
    "data-name": "Path 9670",
    d: "M529.344,331.678h0a15.82,15.82,0,0,0-1.193-4.2l-10.7,3.5-9.727,2.216c-3.606.8-7.963,1.771-11.8,2.638-4.309.979-7.17,4.253-6.227,8.568l1.081,5.234c6.027-.082,31.22-.96,36.79-4.023C530.253,344.131,531.128,339.336,529.344,331.678Z",
    transform: "translate(-462.804 -263.087)",
    fill: "#462103"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12332",
    "data-name": "Group 12332",
    transform: "translate(17.657 51.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9671",
    "data-name": "Path 9671",
    d: "M490.076,304.718s5.086-2.3,6.485.007a3.6,3.6,0,0,1-1.5,4.588,118.652,118.652,0,0,1-20.788,7.441,22.469,22.469,0,0,0-1.032-2.64,48.711,48.711,0,0,0,8.276-4.619,52.758,52.758,0,0,1,8.557-4.777Z",
    transform: "translate(-473.243 -303.698)",
    fill: "#e5918f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9672",
    "data-name": "Path 9672",
    d: "M502.307,276.985l-4.359,17.41s.45,4.4,4.9,2.241,7.391-16.031,7.391-16.031Z",
    transform: "translate(-466.546 -240.687)",
    fill: "#e5918f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9673",
    "data-name": "Path 9673",
    d: "M511.556,278.731c-.539-.13-1.054-.273-1.55-.422s-.992-.3-1.451-.465a24.455,24.455,0,0,1-6.38-3.125,45.723,45.723,0,0,1,4.266-11.967,1.76,1.76,0,0,0,.106-.186l.111-.186a10.886,10.886,0,0,1,3.032-3.156l.366-.254.515,9.09.087.936Z",
    transform: "translate(-468.421 -232.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9674",
    "data-name": "Path 9674",
    d: "M516.643,285.83c-.539-.13-1.054-.273-1.55-.422s-.992-.3-1.451-.465c.87-6.123,1.656-9.971,1.656-9.971l.446,1.122Z",
    transform: "translate(-473.508 -239.794)",
    fill: "#ffead8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9675",
    "data-name": "Path 9675",
    d: "M542.448,260.281c-.106,2.691-.577,7.013-.986,11.353-.13,1.377-.254,2.759-.36,4.092-.074.831-1.326,5.265-1.376,6.058-.223,3.795-2.083,6.635-.322,12.413a9.1,9.1,0,0,1,.527,2.666c0,.4-.515.812-.719.924a12.144,12.144,0,0,1-3.95.943h-.006a102.462,102.462,0,0,1-10.963.5c-3.789,0-9.474-.6-10.194-1.556-.657-.874-.05-2.145.26-3.9,1.4-7.918.9-12.047.812-17.764,0-.142-.006-.285-.006-.434-.142-8.817-.726-16.363-.316-19.085l.366-.254c.6-.41,1.191-.775,1.761-1.1.05-.024.112-.062.174-.1.174-.1.353-.192.521-.285a2,2,0,0,1,.2-.1,43.209,43.209,0,0,1,4.229-1.668c.136-.043.26-.087.366-.118,1.01-.062,2.108-.074,3.292-.043,1.029.031,2.6.167,4.315.391h.006a44.59,44.59,0,0,1,5.729,1.072.333.333,0,0,1,.031.013,11.794,11.794,0,0,1,4.508,3.156A15.269,15.269,0,0,1,542.448,260.281Z",
    transform: "translate(-473.58 -229.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9676",
    "data-name": "Path 9676",
    d: "M555.857,304.784a9.1,9.1,0,0,1,.527,2.666c0,.4-.515.812-.719.924a12.145,12.145,0,0,1-3.95.943,2.8,2.8,0,0,0,1.978-2.276c0-.727-.943-5.636-.682-8.805s.775-8.2-.2-12.227-1.91-9.332-1.91-9.332l5.525,3.336s.713,1,1.495,2.207c-.13,1.377-.254,2.759-.36,4.092C557.482,287.143,554.1,299.005,555.857,304.784Z",
    transform: "translate(-490.034 -240.551)",
    fill: "#fbeadb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12336",
    "data-name": "Group 12336",
    transform: "translate(38.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9677",
    "data-name": "Path 9677",
    d: "M516.13,224.354s.478,5.778,2.394,6.167,1.445-2.067,1.445-2.067l-.268-2.744Z",
    transform: "translate(-513.534 -217.34)",
    fill: "#3d1c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9678",
    "data-name": "Path 9678",
    d: "M530,250.447c-3.751-.447-2.35-4.092-1.836-4.93.136-.043.781-.241.831-.273a.021.021,0,0,1,.013-.006,1.029,1.029,0,0,0,.291-.434,8.9,8.9,0,0,0,.186-3v-.353c.062-.229.124-.447.174-.651l1.972-1.55,4.172-3.281s-1.109,5.488-.217,8.947a1.3,1.3,0,0,0,.552.831c0,.006.006,0,.006,0a1.01,1.01,0,0,0,.416.149C537.581,246.379,536.155,251.178,530,250.447Z",
    transform: "translate(-518.567 -222.492)",
    fill: "#e5918f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9679",
    "data-name": "Path 9679",
    d: "M534.753,242.236a6.224,6.224,0,0,1-4.01,5.346,8.8,8.8,0,0,0,.188-3l1.665-1.308Z",
    transform: "translate(-520.017 -225.273)",
    fill: "#cc6362"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9680",
    "data-name": "Path 9680",
    d: "M517.776,221.26s.867,11.989,4.1,13.007a8.419,8.419,0,0,0,7.085-3.595c.854-1.148,1.931-1.405,2.283-2.791.572-2.251,1.379-6.4.349-8.905C530.133,215.413,517.915,212.583,517.776,221.26Z",
    transform: "translate(-514.265 -213.424)",
    fill: "#e5918f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9681",
    "data-name": "Path 9681",
    d: "M528.849,215.322a3.525,3.525,0,0,0-2.257-2.991c-2.194-1.027-6.755-.584-11.456.465-1.1.246-2.485-.431-3.255.1-.93.645,0,3.594,0,3.594,1.814,5.492,8.487,3.706,10.493,3.028.477,1.414.416,3.38,1.6,4.394a3.89,3.89,0,0,0,3.052.4c.147.28.7.527.813.911a19.4,19.4,0,0,1,.312,4.841l.566-.277C528.79,229.367,534.643,215.5,528.849,215.322Z",
    transform: "translate(-511.465 -211.748)",
    fill: "#3d2109"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12333",
    "data-name": "Group 12333",
    transform: "translate(3.992 9.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9682",
    "data-name": "Path 9682",
    d: "M521.48,231.829a1.468,1.468,0,1,1-1.71-1.564A1.664,1.664,0,0,1,521.48,231.829Z",
    transform: "translate(-518.64 -229.518)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.501
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9683",
    "data-name": "Path 9683",
    d: "M528.51,230.515a1.468,1.468,0,1,1-1.71-1.564A1.664,1.664,0,0,1,528.51,230.515Z",
    transform: "translate(-521.759 -228.935)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.501
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9684",
    "data-name": "Path 9684",
    d: "M523.744,232.918s.171-.279,1.072-.2",
    transform: "translate(-520.904 -230.607)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.501
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    y1: 0.534,
    x2: 3.344,
    transform: "translate(6.785 1.285)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.501
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12334",
    "data-name": "Group 12334",
    transform: "translate(13.411 10.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9685",
    "data-name": "Path 9685",
    d: "M536.524,234.847c2.3.882,3.022-4.786.835-5.037-1.658-.19-1.726,2.123-1.726,2.123S535.209,234.344,536.524,234.847Z",
    transform: "translate(-535.568 -229.799)",
    fill: "#e5918f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12335",
    "data-name": "Group 12335",
    transform: "translate(14.346 10.909)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9686",
    "data-name": "Path 9686",
    d: "M538.029,231.355s-1.36.72-.487,2.929",
    transform: "translate(-537.25 -231.355)",
    fill: "none",
    stroke: "#cc6362",
    strokeMiterlimit: 10,
    strokeWidth: 0.724
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9687",
    "data-name": "Path 9687",
    d: "M538.405,233.289a1.2,1.2,0,0,0-1.118.83",
    transform: "translate(-537.266 -232.213)",
    fill: "none",
    stroke: "#cc6362",
    strokeMiterlimit: 10,
    strokeWidth: 0.724
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9688",
    "data-name": "Path 9688",
    d: "M567.692,295.026v.006c-1.012,1.174-4.852,2.03-6.7.406a10.721,10.721,0,0,1-1.88-3.572,110.585,110.585,0,0,1-3.189-10.8l8.594-4.392s1.106,4.958,2.058,9.669c0,0,.008.048.026.131.31,1.509.6,2.993.825,4.267a.593.593,0,0,1,.017.1A18.051,18.051,0,0,1,567.692,295.026Z",
    transform: "translate(-492.263 -240.551)",
    fill: "#e5918f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9689",
    "data-name": "Path 9689",
    d: "M550.089,266.416a103.222,103.222,0,0,0,3.439,9.991,13.613,13.613,0,0,0,6.307-.763,11.622,11.622,0,0,0,4.018-2.61s-1.73-4.862-3.283-8.355c-1.394-3.136-2.231-4.307-2.834-4.928a13.659,13.659,0,0,0-3.412-2.538Z",
    transform: "translate(-489.676 -231.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9690",
    "data-name": "Path 9690",
    d: "M562.432,267.906l-5.043-2.176-3.974-10.239s.728.221,1.688.609h0c.018.009.06.023.129.051a.523.523,0,0,1,.073.032c.857.4,4.181,2.36,6.482,9.478l.055.18c.244.821.424,1.48.521,1.821.009.032.019.065.028.1S562.419,267.86,562.432,267.906Z",
    transform: "translate(-491.151 -231.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12337",
    "data-name": "Group 12337",
    transform: "translate(43.176 45.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9691",
    "data-name": "Path 9691",
    d: "M556,302.633v.006c-.074.629-.248,1.082-.559,1.242-.049.032-.755.452-.8.484a42.89,42.89,0,0,1-5.327,2.755,193,193,0,0,1-18.6,6.684,21.929,21.929,0,0,0-1.138-2.6,48.735,48.735,0,0,0,8.076-4.958c4.009-3.06,9.775-6.776,9.775-6.776l1.456-1.713s5.176-4.764,6.007-3.806c0,0,.008.048.026.131.124.5.534,2.325.825,4.267a.6.6,0,0,1,.017.1A18.051,18.051,0,0,1,556,302.633Z",
    transform: "translate(-523.75 -293.826)",
    fill: "#e5918f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9692",
    "data-name": "Path 9692",
    d: "M525.526,323.973a3.2,3.2,0,0,1-2.043.393c-.57-.12-.8-.353-1.222-.427a9.5,9.5,0,0,1-2.1-.486c-.556-.273-.773-.3-.753.255s1.117,1.041,1.414,1.2a2.82,2.82,0,0,1,.711.712c.041.062-1.829,1.04-2.331.842a1.455,1.455,0,0,0-.065.7c.085.251.47.339.5.466s-.088.384-.005.585.426.2.565.526-.014.331.087.67.535.4.618.576.039.38.221.5a8.473,8.473,0,0,0,2.477-.682c.613-.263,2.253-2.624,4.068-3.429Z",
    transform: "translate(-519.109 -306.884)",
    fill: "#e5918f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9693",
    "data-name": "Path 9693",
    d: "M535.659,342.457H522.585v-1.279h13.074a.639.639,0,0,1,.64.639h0A.64.64,0,0,1,535.659,342.457Z",
    transform: "translate(-477.475 -269.164)",
    fill: "#7a512e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9694",
    "data-name": "Path 9694",
    d: "M501.234,322.892H468.5a.872.872,0,0,1-.841-.639l-6.7-24.118a.838.838,0,0,1,.807-1.062h31.655a1.642,1.642,0,0,1,1.582,1.2l6.676,24.031A.462.462,0,0,1,501.234,322.892Z",
    transform: "translate(-450.123 -249.598)",
    fill: "#7a512e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9695",
    "data-name": "Path 9695",
    d: "M499.1,322.892H466.37a.873.873,0,0,1-.841-.639l-6.7-24.118a.838.838,0,0,1,.807-1.062h31.655a1.642,1.642,0,0,1,1.582,1.2l6.676,24.031A.462.462,0,0,1,499.1,322.892Z",
    transform: "translate(-449.179 -249.598)",
    fill: "#f28f3b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12340",
    "data-name": "Group 12340",
    transform: "translate(124.672 180.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9696",
    "data-name": "Path 9696",
    d: "M298.064,307.339l3.792-3.888a10.17,10.17,0,0,1,.338-2.1,9.647,9.647,0,0,1,1.005-1.867,1.374,1.374,0,0,1,.8,0,3.65,3.65,0,0,1,.763-.177,2.237,2.237,0,0,1,.678.216s.567-.038.8-.038a.5.5,0,0,1,.312.066,16.74,16.74,0,0,1,1.357-1.406c.443-.354,1.12-1.007,1.321-1s.273.335.135.689a3.927,3.927,0,0,1-.737.926l-1.728,2.618a3.717,3.717,0,0,0,.452-.216c.157-.1,1.211-1.083,1.275-1.122s.536-.354.812-.039-1.809,2.811-2.144,3.146a18.263,18.263,0,0,1-2.251,1.3s-2.023,3.639-2.22,3.875S298.064,307.339,298.064,307.339Z",
    transform: "translate(-234.762 -280.892)",
    fill: "#e49191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9697",
    "data-name": "Path 9697",
    d: "M293.247,278.1s-2.118,12.27-4.112,12.555c0,0-7.959.321-9.732-9.335-1.538-8.373,4.63-10.159,7.514-9.518S293.867,272.86,293.247,278.1Z",
    transform: "translate(-226.377 -269.6)",
    fill: "#e49191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9698",
    "data-name": "Path 9698",
    d: "M285.555,296.939s-1.115,1.5-1.506,5.143a11.816,11.816,0,0,1-6.371-1.1,45.093,45.093,0,0,0,1.849-10.711",
    transform: "translate(-225.72 -277.845)",
    fill: "#e49191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9699",
    "data-name": "Path 9699",
    d: "M282.651,268.087c-4.349.961-4,3.671-4,3.671-2.036.5-2.474,1.345-2.457,5.1s1.377,8.272,2.127,8.639a20.126,20.126,0,0,0,5.357.256c.355-.129,1.843-3.577,1.5-4.184s.017-2.992,1.008-3.082.8,1.444.8,1.444l.814-.179.629-1.541c5.748.342,7.233-6.208,7.233-6.208C294.271,271.106,287,267.126,282.651,268.087Z",
    transform: "translate(-225.06 -267.938)",
    fill: "#3b1b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9700",
    "data-name": "Path 9700",
    d: "M199.073,417.444l4.4.635-1.457,5.136-4.763-1.2a3.1,3.1,0,0,1,.988-4.57A1.6,1.6,0,0,1,199.073,417.444Z",
    transform: "translate(-189.763 -334.234)",
    fill: "#e5918f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9701",
    "data-name": "Path 9701",
    d: "M235.2,377.887l-6.482-19.626s-1.965-.7-2.971,0c0,0-6.752,3.631-6.032,13.985a169.171,169.171,0,0,0,2.859,19.665l-17.293-.64a5.892,5.892,0,0,0-.753,5.837s21.731,5.844,24.791,6.384c2.488.44,5.211.778,6.525-.349C238.156,401.159,235.2,377.887,235.2,377.887Z",
    transform: "translate(-193.061 -307.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9702",
    "data-name": "Path 9702",
    d: "M235.874,417.444l4.4.635-1.457,5.136-4.763-1.2a3.1,3.1,0,0,1,.988-4.57A1.6,1.6,0,0,1,235.874,417.444Z",
    transform: "translate(-206.088 -334.234)",
    fill: "#e5918f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9703",
    "data-name": "Path 9703",
    d: "M228.809,419.086c-.1,1.011.786,1.921.624,2.173s-3.118,5.212-3.118,5.212,2.232.972,1.872,2.376h-5.652a4.692,4.692,0,0,1-1.44-3.24,16.4,16.4,0,0,1,1.392-4.14c1.008-1.944,3.3-6.333,3.3-6.333a3.2,3.2,0,0,1,1.884.036,11.426,11.426,0,0,1,2.734,1.223S229.053,416.588,228.809,419.086Z",
    transform: "translate(-200.619 -333.184)",
    fill: "#f28f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M282.449,399.269c-1.4-5.207-14.525-27.435-18.967-33.437-9.123-3.961-18.846-7.322-18.846-7.322-4.021.96-6,9.063-3.721,14.465,1.565,3.706,11.491,13.033,17.569,18.524l-16.868-.02s-1.987,2.97-.186,5.791c0,0,28.054,6.379,30.515,6.739a55.925,55.925,0,0,0,7.983,0S283.624,403.652,282.449,399.269Z",
    transform: "translate(-208.984 -308.115)",
    fill: "#371900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9705",
    "data-name": "Path 9705",
    d: "M192.008,419.086c-.1,1.011.786,1.921.624,2.173s-3.119,5.212-3.119,5.212,2.232.972,1.872,2.376h-5.652a4.689,4.689,0,0,1-1.44-3.24,16.4,16.4,0,0,1,1.392-4.14c1.008-1.944,3.3-6.333,3.3-6.333a3.2,3.2,0,0,1,1.884.036,11.438,11.438,0,0,1,2.734,1.223S192.252,416.588,192.008,419.086Z",
    transform: "translate(-184.294 -333.184)",
    fill: "#f28f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9706",
    "data-name": "Path 9706",
    d: "M337.636,308.679l-9.048,15.915-6.48-6.459-5.363,7.983,1.557.748-.56.466s12.5,6.09,14,4.747,8.48-21.59,8.48-21.59Z",
    transform: "translate(-243.049 -286.011)",
    fill: "#e49191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9707",
    "data-name": "Path 9707",
    d: "M289.122,316.824s-1.708,7.205-5.124,10.622l-8.741-3.327s-4.056,6.821-8.023,12.052c-1.525,2.02-2.031,4.863-3.822,5.236-.111-.039-.217-.072-.328-.1-4.857-1.458-12.024.089-17.938-2.109-6.532-2.432-5.264-3.8-5.264-3.8a84.381,84.381,0,0,0,6.209-14.7,90.127,90.127,0,0,0,2.159-8.863,10.206,10.206,0,0,1,8.591-8.218c.05-.006.095-.017.145-.022,4.952-.629,17.916.9,20.436,1.981S289.122,316.824,289.122,316.824Z",
    transform: "translate(-208.908 -283.69)",
    fill: "#f28f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9708",
    "data-name": "Path 9708",
    d: "M294.1,339.678s-4.056,6.821-8.023,12.052c-1.525,2.02-2.031,4.863-3.822,5.236.785-.278,2.086-4.407,2.548-5.336s1.207-1.853,2.81-5.1,3.765-8.012,3.765-8.012Z",
    transform: "translate(-227.747 -299.249)",
    fill: "#e39b5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9709",
    "data-name": "Path 9709",
    d: "M273.26,417.8a28.307,28.307,0,0,1,8.72,1.253",
    transform: "translate(-223.759 -334.413)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.065
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9710",
    "data-name": "Path 9710",
    d: "M360.634,295.88a8.466,8.466,0,0,0-1.521,1.1l.516-.988a9.718,9.718,0,0,0,.928-1.02c.246-.362.116-.723-.077-.743a7.577,7.577,0,0,0-1.425,1.019l.1-.2a9.718,9.718,0,0,0,.928-1.02c.245-.362.116-.723-.077-.743a12.211,12.211,0,0,0-1.763,1.3l-.765,1.023.576-1.119a4.826,4.826,0,0,0,.506-.776c.2-.4.056-.529-.056-.663s-1.169.652-1.439.966a16.315,16.315,0,0,0-1.191,1.77l-.883,1.827c-.057-.529-.145-1.435-.208-2.012-.09-.832-.843-1.029-.869-.624a21.172,21.172,0,0,0-.351,3.473c.095,1.079.275,1.787.343,2.394a4.766,4.766,0,0,1-.562,1.82s2.518,1.563,2.934,1.1a19.664,19.664,0,0,0,1.73-2.207,11.755,11.755,0,0,0,.985-2.226l.787-1.681a9.722,9.722,0,0,0,.928-1.02C360.957,296.26,360.828,295.9,360.634,295.88Z",
    transform: "translate(-259.286 -279.069)",
    fill: "#e49191"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12342",
    "data-name": "Group 12342",
    transform: "translate(337.593 146.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9711",
    "data-name": "Path 9711",
    d: "M599.921,207.074H570.4a3.426,3.426,0,0,0-3.426,3.426v6.974a3.428,3.428,0,0,0,2.994,3.4.493.493,0,0,1,.432.49v3.819a.227.227,0,0,0,.412.132l3.007-4.205a.5.5,0,0,1,.405-.209h25.7a3.426,3.426,0,0,0,3.426-3.426V210.5A3.426,3.426,0,0,0,599.921,207.074Z",
    transform: "translate(-566.97 -207.074)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12341",
    "data-name": "Group 12341",
    transform: "translate(5.7 5.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9712",
    "data-name": "Path 9712",
    d: "M579.47,218.581a1.128,1.128,0,1,1-1.128-1.128A1.128,1.128,0,0,1,579.47,218.581Z",
    transform: "translate(-577.214 -217.453)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9713",
    "data-name": "Path 9713",
    d: "M589.679,218.581a1.128,1.128,0,1,1-1.128-1.128A1.128,1.128,0,0,1,589.679,218.581Z",
    transform: "translate(-581.743 -217.453)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9714",
    "data-name": "Path 9714",
    d: "M599.889,218.581a1.128,1.128,0,1,1-1.128-1.128A1.127,1.127,0,0,1,599.889,218.581Z",
    transform: "translate(-586.272 -217.453)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9715",
    "data-name": "Path 9715",
    d: "M610.1,218.581a1.128,1.128,0,1,1-1.128-1.128A1.128,1.128,0,0,1,610.1,218.581Z",
    transform: "translate(-590.801 -217.453)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9716",
    "data-name": "Path 9716",
    d: "M620.307,218.581a1.128,1.128,0,1,1-1.128-1.128A1.127,1.127,0,0,1,620.307,218.581Z",
    transform: "translate(-595.329 -217.453)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12344",
    "data-name": "Group 12344",
    transform: "translate(133.819 177.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9717",
    "data-name": "Path 9717",
    d: "M204.159,262.031h29.525a3.426,3.426,0,0,1,3.426,3.426v6.975a3.426,3.426,0,0,1-2.993,3.4.494.494,0,0,0-.432.491v3.818a.227.227,0,0,1-.412.132l-3.007-4.205a.5.5,0,0,0-.405-.208h-25.7a3.426,3.426,0,0,1-3.426-3.426v-6.975A3.426,3.426,0,0,1,204.159,262.031Z",
    transform: "translate(-200.733 -262.031)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12343",
    "data-name": "Group 12343",
    transform: "translate(5.7 5.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9718",
    "data-name": "Path 9718",
    d: "M251.814,273.538a1.128,1.128,0,1,0,1.128-1.128A1.128,1.128,0,0,0,251.814,273.538Z",
    transform: "translate(-229.092 -272.41)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9719",
    "data-name": "Path 9719",
    d: "M241.605,273.538a1.128,1.128,0,1,0,1.128-1.128A1.128,1.128,0,0,0,241.605,273.538Z",
    transform: "translate(-224.564 -272.41)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9720",
    "data-name": "Path 9720",
    d: "M231.4,273.538a1.128,1.128,0,1,0,1.128-1.128A1.128,1.128,0,0,0,231.4,273.538Z",
    transform: "translate(-220.034 -272.41)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9721",
    "data-name": "Path 9721",
    d: "M221.186,273.538a1.128,1.128,0,1,0,1.128-1.128A1.128,1.128,0,0,0,221.186,273.538Z",
    transform: "translate(-215.506 -272.41)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9722",
    "data-name": "Path 9722",
    d: "M210.977,273.538a1.128,1.128,0,1,0,1.128-1.128A1.128,1.128,0,0,0,210.977,273.538Z",
    transform: "translate(-210.977 -272.41)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12346",
    "data-name": "Group 12346",
    transform: "translate(256.366 120.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9723",
    "data-name": "Path 9723",
    d: "M480.17,169.585H426.358a5.374,5.374,0,0,1-5.374-5.374h0a5.374,5.374,0,0,1,5.374-5.374H480.17a5.374,5.374,0,0,1,5.374,5.374h0A5.374,5.374,0,0,1,480.17,169.585Z",
    transform: "translate(-420.984 -158.838)",
    fill: "#fff",
    stroke: "#ff8e2e",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12345",
    "data-name": "Group 12345",
    transform: "translate(52.683 2.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9724",
    "data-name": "Path 9724",
    d: "M521.384,165.552a2.858,2.858,0,1,1-2.858-2.858A2.858,2.858,0,0,1,521.384,165.552Z",
    transform: "translate(-515.669 -162.694)",
    fill: "none",
    stroke: "#f28f3b",
    strokeMiterlimit: 10,
    strokeWidth: 1.672
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    x2: 1.578,
    y2: 1.578,
    transform: "translate(4.878 4.879)",
    fill: "none",
    stroke: "#f28f3b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.672
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12369",
    "data-name": "Group 12369",
    transform: "translate(97.325 71.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12347",
    "data-name": "Group 12347",
    transform: "translate(114.854 183.484)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4195",
    "data-name": "Rectangle 4195",
    width: 22.115,
    height: 22.115,
    rx: 7.708,
    transform: "translate(4.03 0)",
    fill: "#4b3727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4196",
    "data-name": "Rectangle 4196",
    width: 22.115,
    height: 22.115,
    rx: 7.708,
    transform: "translate(0 0)",
    fill: "#f28f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9725",
    "data-name": "Path 9725",
    d: "M356.044,413.39l6.349,3.665a.588.588,0,0,1,0,1.018l-6.349,3.665a.587.587,0,0,1-.881-.509V413.9A.588.588,0,0,1,356.044,413.39Z",
    transform: "translate(-347.599 -406.506)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12348",
    "data-name": "Group 12348",
    transform: "translate(248.175 176.69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4197",
    "data-name": "Rectangle 4197",
    width: 28.91,
    height: 28.91,
    rx: 10.076,
    transform: "translate(5.269 0)",
    fill: "#473525"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4198",
    "data-name": "Rectangle 4198",
    width: 28.91,
    height: 28.91,
    rx: 10.076,
    transform: "translate(0 0)",
    fill: "#f28f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9726",
    "data-name": "Path 9726",
    d: "M607.867,398.849a3.473,3.473,0,1,1-3.474-3.474A3.473,3.473,0,0,1,607.867,398.849Z",
    transform: "translate(-589.938 -391.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9727",
    "data-name": "Path 9727",
    d: "M608.63,416.981v5.128a.839.839,0,0,1-.839.839h-12.8a.839.839,0,0,1-.839-.839v-5.128a7.241,7.241,0,0,1,7.241-7.24h0A7.24,7.24,0,0,1,608.63,416.981Z",
    transform: "translate(-586.934 -398.128)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12349",
    "data-name": "Group 12349",
    transform: "translate(185.758 63.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9728",
    "data-name": "Path 9728",
    d: "M481.222,187.918H469.855a.854.854,0,0,1-.854-.854h0a.855.855,0,0,1,.854-.854h11.367a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,481.222,187.918Z",
    transform: "translate(-469.001 -186.21)",
    fill: "#fff7f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9729",
    "data-name": "Path 9729",
    d: "M504.163,187.918h-8.226a.854.854,0,0,1-.854-.854h0a.855.855,0,0,1,.854-.854h8.226a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,504.163,187.918Z",
    transform: "translate(-480.571 -186.21)",
    fill: "#fff7f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9730",
    "data-name": "Path 9730",
    d: "M474.685,194.668h-4.83a.854.854,0,0,1-.854-.854h0a.855.855,0,0,1,.854-.854h4.83a.855.855,0,0,1,.854.854h0A.854.854,0,0,1,474.685,194.668Z",
    transform: "translate(-469.001 -189.204)",
    fill: "#fff7f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9731",
    "data-name": "Path 9731",
    d: "M498.729,194.668H483.687a.854.854,0,0,1-.854-.854h0a.855.855,0,0,1,.854-.854h15.042a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,498.729,194.668Z",
    transform: "translate(-475.137 -189.204)",
    fill: "#fff7f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9732",
    "data-name": "Path 9732",
    d: "M484.838,201.418H469.855a.854.854,0,0,1-.854-.854h0a.855.855,0,0,1,.854-.854h14.983a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,484.838,201.418Z",
    transform: "translate(-469.001 -192.199)",
    fill: "#fff7f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9733",
    "data-name": "Path 9733",
    d: "M506.871,201.418h-4.829a.854.854,0,0,1-.855-.854h0a.855.855,0,0,1,.855-.854h4.829a.854.854,0,0,1,.854.854h0A.854.854,0,0,1,506.871,201.418Z",
    transform: "translate(-483.279 -192.199)",
    fill: "#fff7f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12353",
    "data-name": "Group 12353",
    transform: "translate(12.239 128.593)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4199",
    "data-name": "Rectangle 4199",
    width: 43.934,
    height: 24.285,
    rx: 3.823,
    transform: "translate(0 0)",
    fill: "#402e20"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x2: 40.2,
    transform: "translate(1.867 3.281)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_440",
    "data-name": "Ellipse 440",
    cx: 0.487,
    cy: 0.487,
    r: 0.487,
    transform: "translate(40.519 1.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_441",
    "data-name": "Ellipse 441",
    cx: 0.487,
    cy: 0.487,
    r: 0.487,
    transform: "translate(37.98 1.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_442",
    "data-name": "Ellipse 442",
    cx: 0.487,
    cy: 0.487,
    r: 0.487,
    transform: "translate(35.442 1.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12352",
    "data-name": "Group 12352",
    transform: "translate(1.867 5.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12350",
    "data-name": "Group 12350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9734",
    "data-name": "Path 9734",
    d: "M167.991,313.126h-6.821a.672.672,0,0,1-.672-.672h0a.673.673,0,0,1,.672-.673h6.821a.673.673,0,0,1,.672.673h0A.672.672,0,0,1,167.991,313.126Z",
    transform: "translate(-160.497 -311.781)",
    fill: "#c48a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9735",
    "data-name": "Path 9735",
    d: "M167.991,318.709h-6.821a.672.672,0,0,1-.672-.672h0a.672.672,0,0,1,.672-.672h6.821a.672.672,0,0,1,.672.672h0A.672.672,0,0,1,167.991,318.709Z",
    transform: "translate(-160.497 -314.258)",
    fill: "#c48a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9736",
    "data-name": "Path 9736",
    d: "M167.991,324.293h-6.821a.672.672,0,0,1-.672-.673h0a.672.672,0,0,1,.672-.672h6.821a.672.672,0,0,1,.672.672h0A.672.672,0,0,1,167.991,324.293Z",
    transform: "translate(-160.497 -316.735)",
    fill: "#c48a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9737",
    "data-name": "Path 9737",
    d: "M167.991,329.876h-6.821a.672.672,0,0,1-.672-.672h0a.673.673,0,0,1,.672-.673h6.821a.673.673,0,0,1,.672.673h0A.672.672,0,0,1,167.991,329.876Z",
    transform: "translate(-160.497 -319.211)",
    fill: "#c48a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9738",
    "data-name": "Path 9738",
    d: "M167.991,335.459h-6.821a.672.672,0,0,1-.672-.672h0a.672.672,0,0,1,.672-.672h6.821a.672.672,0,0,1,.672.672h0A.672.672,0,0,1,167.991,335.459Z",
    transform: "translate(-160.497 -321.688)",
    fill: "#c48a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9739",
    "data-name": "Path 9739",
    d: "M167.991,341.043h-6.821a.672.672,0,0,1-.672-.673h0a.672.672,0,0,1,.672-.672h6.821a.672.672,0,0,1,.672.672h0A.672.672,0,0,1,167.991,341.043Z",
    transform: "translate(-160.497 -324.165)",
    fill: "#c48a5a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12351",
    "data-name": "Group 12351",
    transform: "translate(9.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9740",
    "data-name": "Path 9740",
    d: "M207.565,313.126h-29.4a.672.672,0,0,1-.672-.672h0a.673.673,0,0,1,.672-.673h29.4a.673.673,0,0,1,.673.673h0A.672.672,0,0,1,207.565,313.126Z",
    transform: "translate(-177.497 -311.781)",
    fill: "#a85d1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9741",
    "data-name": "Path 9741",
    d: "M207.565,318.709h-29.4a.672.672,0,0,1-.672-.672h0a.672.672,0,0,1,.672-.672h29.4a.672.672,0,0,1,.673.672h0A.672.672,0,0,1,207.565,318.709Z",
    transform: "translate(-177.497 -314.258)",
    fill: "#a85d1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9742",
    "data-name": "Path 9742",
    d: "M207.565,324.293h-29.4a.672.672,0,0,1-.672-.673h0a.672.672,0,0,1,.672-.672h29.4a.672.672,0,0,1,.673.672h0A.672.672,0,0,1,207.565,324.293Z",
    transform: "translate(-177.497 -316.735)",
    fill: "#a85d1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9743",
    "data-name": "Path 9743",
    d: "M207.565,329.876h-29.4a.672.672,0,0,1-.672-.672h0a.673.673,0,0,1,.672-.673h29.4a.673.673,0,0,1,.673.673h0A.672.672,0,0,1,207.565,329.876Z",
    transform: "translate(-177.497 -319.211)",
    fill: "#a85d1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9744",
    "data-name": "Path 9744",
    d: "M207.565,335.459h-29.4a.672.672,0,0,1-.672-.672h0a.672.672,0,0,1,.672-.672h29.4a.672.672,0,0,1,.673.672h0A.672.672,0,0,1,207.565,335.459Z",
    transform: "translate(-177.497 -321.688)",
    fill: "#a85d1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9745",
    "data-name": "Path 9745",
    d: "M207.565,341.043h-29.4a.672.672,0,0,1-.672-.673h0a.672.672,0,0,1,.672-.672h29.4a.672.672,0,0,1,.673.672h0A.672.672,0,0,1,207.565,341.043Z",
    transform: "translate(-177.497 -324.165)",
    fill: "#a85d1e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12357",
    "data-name": "Group 12357",
    transform: "translate(220.633)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_443",
    "data-name": "Ellipse 443",
    cx: 18.086,
    cy: 18.086,
    r: 18.086,
    transform: "matrix(0.233, -0.972, 0.972, 0.233, 0, 35.176)",
    fill: "none",
    stroke: "#253348",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    cx: 15.724,
    cy: 15.724,
    r: 15.724,
    transform: "translate(1.061 13.785) rotate(-23.868)",
    fill: "#ff8e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9746",
    "data-name": "Path 9746",
    d: "M571.155,109.354a1.431,1.431,0,1,1-1.431-1.432A1.431,1.431,0,0,1,571.155,109.354Z",
    transform: "translate(-547.922 -87.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9747",
    "data-name": "Path 9747",
    d: "M566.368,102.67h0a.448.448,0,0,1-.609-.174l-4.624-8.341a.448.448,0,0,1,.174-.609h0a.448.448,0,0,1,.609.174l4.624,8.341A.448.448,0,0,1,566.368,102.67Z",
    transform: "translate(-544.722 -81.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9748",
    "data-name": "Path 9748",
    d: "M571.17,110.8h0a.448.448,0,0,1,.633,0l4,4a.447.447,0,0,1,0,.633h0a.447.447,0,0,1-.633,0l-4-4A.448.448,0,0,1,571.17,110.8Z",
    transform: "translate(-549.14 -88.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12354",
    "data-name": "Group 12354",
    transform: "translate(7.408 7.408)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    y1: 1.808,
    transform: "translate(14.49)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    x2: 1.808,
    transform: "translate(26.979 14.49)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    y2: 1.808,
    transform: "translate(14.298 26.979)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    x1: 1.808,
    transform: "translate(0 14.298)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12355",
    "data-name": "Group 12355",
    transform: "translate(9.288 9.288)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    x1: 0.904,
    y1: 1.566,
    transform: "translate(5.4)",
    fill: "none",
    stroke: "#fff3e9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290",
    "data-name": "Line 290",
    y1: 0.904,
    x2: 1.566,
    transform: "translate(23.461 5.4)",
    fill: "none",
    stroke: "#fff3e9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    x2: 0.904,
    y2: 1.566,
    transform: "translate(18.723 23.461)",
    fill: "none",
    stroke: "#fff3e9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    x1: 1.566,
    y2: 0.904,
    transform: "translate(0 18.723)",
    fill: "none",
    stroke: "#fff3e9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12356",
    "data-name": "Group 12356",
    transform: "translate(9.385 9.385)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_293",
    "data-name": "Line 293",
    x1: 1.566,
    y1: 0.904,
    transform: "translate(0 5.137)",
    fill: "none",
    stroke: "#fff3e9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    y1: 1.566,
    x2: 0.904,
    transform: "translate(18.793)",
    fill: "none",
    stroke: "#fff3e9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    x2: 1.566,
    y2: 0.904,
    transform: "translate(23.269 18.793)",
    fill: "none",
    stroke: "#fff3e9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    x1: 0.904,
    y2: 1.566,
    transform: "translate(5.137 23.269)",
    fill: "none",
    stroke: "#fff3e9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12360",
    "data-name": "Group 12360",
    transform: "translate(0 79.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4200",
    "data-name": "Rectangle 4200",
    width: 30.509,
    height: 30.509,
    rx: 9.569,
    transform: "translate(2.365 2.643)",
    fill: "#473424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4201",
    "data-name": "Rectangle 4201",
    width: 30.509,
    height: 30.509,
    rx: 7.667,
    fill: "#f28f3b",
    stroke: "#fff2e8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12359",
    "data-name": "Group 12359",
    transform: "translate(8.48 4.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12358",
    "data-name": "Group 12358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9749",
    "data-name": "Path 9749",
    d: "M162.442,230.092h-.159v-1.748a5.2,5.2,0,1,0-10.4,0v1.748h-.035a1.459,1.459,0,0,0-1.459,1.459v6.586a1.46,1.46,0,0,0,1.459,1.46h10.6a1.46,1.46,0,0,0,1.46-1.46v-6.586A1.46,1.46,0,0,0,162.442,230.092Zm-9.245-1.748a3.884,3.884,0,1,1,7.768,0v1.748H153.2Z",
    transform: "translate(-150.385 -223.141)",
    fill: "#ffead8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9750",
    "data-name": "Path 9750",
    d: "M162.9,240.364a1.7,1.7,0,1,0-2.553,1.463.3.3,0,0,1,.154.341l-.3,1.091a1.019,1.019,0,1,0,1.968,0l-.292-1.079a.305.305,0,0,1,.158-.343A1.69,1.69,0,0,0,162.9,240.364Z",
    transform: "translate(-154.433 -230.028)",
    fill: "#f38528"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9751",
    "data-name": "Path 9751",
    d: "M163.276,255.87H151.011a.625.625,0,0,1-.626-.626h0a.626.626,0,0,1,.626-.626h12.265a.626.626,0,0,1,.626.626h0A.626.626,0,0,1,163.276,255.87Z",
    transform: "translate(-150.385 -237.104)",
    fill: "#ffead8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9752",
    "data-name": "Path 9752",
    d: "M163.276,259.683H151.011a.626.626,0,0,1-.626-.626h0a.625.625,0,0,1,.626-.626h12.265a.626.626,0,0,1,.626.626h0A.626.626,0,0,1,163.276,259.683Z",
    transform: "translate(-150.385 -238.796)",
    fill: "#ffead8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12367",
    "data-name": "Group 12367",
    transform: "translate(251.648 129.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12361",
    "data-name": "Group 12361",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4202",
    "data-name": "Rectangle 4202",
    d: "M5.634,0h6.694a5.634,5.634,0,0,1,5.634,5.634v6.694a5.633,5.633,0,0,1-5.633,5.633H5.634A5.634,5.634,0,0,1,0,12.328V5.634A5.634,5.634,0,0,1,5.634,0Z",
    transform: "translate(1.392 1.556)",
    fill: "#8b501d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4203",
    "data-name": "Rectangle 4203",
    width: 17.961,
    height: 17.961,
    rx: 4.513,
    fill: "#ff851d",
    stroke: "#ffecdc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12366",
    "data-name": "Group 12366",
    transform: "translate(3.616 3.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12362",
    "data-name": "Group 12362",
    transform: "translate(1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9753",
    "data-name": "Path 9753",
    d: "M596.6,320.681a.529.529,0,0,1-.152-.021.555.555,0,0,1-.384-.686l2.716-9.615a.556.556,0,1,1,1.07.3l-2.716,9.615A.556.556,0,0,1,596.6,320.681Z",
    transform: "translate(-596.041 -309.953)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12363",
    "data-name": "Group 12363",
    transform: "translate(5.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9754",
    "data-name": "Path 9754",
    d: "M604.761,320.681a.523.523,0,0,1-.151-.021.555.555,0,0,1-.384-.686l2.717-9.615a.556.556,0,1,1,1.07.3l-2.717,9.615A.556.556,0,0,1,604.761,320.681Z",
    transform: "translate(-604.204 -309.953)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12364",
    "data-name": "Group 12364",
    transform: "translate(0 2.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9755",
    "data-name": "Path 9755",
    d: "M604.094,315.792h-9.615a.556.556,0,0,1,0-1.113h9.615a.556.556,0,0,1,0,1.113Z",
    transform: "translate(-593.923 -314.679)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12365",
    "data-name": "Group 12365",
    transform: "translate(0 7.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9756",
    "data-name": "Path 9756",
    d: "M604.094,323.686h-9.615a.556.556,0,0,1,0-1.113h9.615a.556.556,0,0,1,0,1.113Z",
    transform: "translate(-593.923 -322.573)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12368",
    "data-name": "Group 12368",
    transform: "translate(43.321 90.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9757",
    "data-name": "Path 9757",
    d: "M220.721,234.775h-6.954a.763.763,0,0,1-.763-.763h0a.763.763,0,0,1,.763-.762h6.954a.762.762,0,0,1,.762.762h0A.762.762,0,0,1,220.721,234.775Z",
    transform: "translate(-213.004 -233.25)",
    fill: "#fef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9758",
    "data-name": "Path 9758",
    d: "M227.726,240.858H213.767A.762.762,0,0,1,213,240.1h0a.763.763,0,0,1,.763-.763h13.959a.762.762,0,0,1,.762.763h0A.762.762,0,0,1,227.726,240.858Z",
    transform: "translate(-213.004 -235.948)",
    fill: "#fef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9759",
    "data-name": "Path 9759",
    d: "M215.415,246.942h-1.649a.763.763,0,0,1-.763-.763h0a.762.762,0,0,1,.763-.762h1.649a.762.762,0,0,1,.762.762h0A.762.762,0,0,1,215.415,246.942Z",
    transform: "translate(-213.004 -238.647)",
    fill: "#fef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9760",
    "data-name": "Path 9760",
    d: "M231.106,246.942h-9.72a.762.762,0,0,1-.762-.763h0a.762.762,0,0,1,.762-.762h9.72a.762.762,0,0,1,.762.762h0A.762.762,0,0,1,231.106,246.942Z",
    transform: "translate(-216.384 -238.647)",
    fill: "#fef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9761",
    "data-name": "Path 9761",
    d: "M235.495,234.775h-4.215a.763.763,0,0,1-.762-.763h0a.763.763,0,0,1,.762-.762h4.215a.762.762,0,0,1,.762.762h0A.762.762,0,0,1,235.495,234.775Z",
    transform: "translate(-220.773 -233.25)",
    fill: "#fef3eb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9762",
    "data-name": "Path 9762",
    d: "M155.013,419.78a4.829,4.829,0,0,0-2.479.681,5.2,5.2,0,0,0-10.336,1.155,3.971,3.971,0,1,0-.736,7.873h13.551a4.855,4.855,0,1,0,0-9.709Z",
    transform: "translate(-136.185 -224.147)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12372",
    "data-name": "Group 12372",
    transform: "translate(64.834 216.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9763",
    "data-name": "Path 9763",
    d: "M96.433,362.122a5.118,5.118,0,0,1,.07-2.184,21.629,21.629,0,0,0-.244-11.761c-2.6-8.115-13.133-15.3-13.133-15.3s2.859,11.976,5.21,17.075a64.232,64.232,0,0,0,6.4,10.219,4.992,4.992,0,0,1,.919,2.1A87.361,87.361,0,0,1,97.109,379.1l.791.031A88.185,88.185,0,0,0,96.433,362.122Z",
    transform: "translate(-79.578 -332.874)",
    fill: "#fcebdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9764",
    "data-name": "Path 9764",
    d: "M116.3,360.24a94.816,94.816,0,0,0,3.065-14.409s-9.444,7.793-10.218,13.823a20.237,20.237,0,0,0,.644,8.4,5.745,5.745,0,0,1,.223,2.283,79.944,79.944,0,0,0-.195,15.778l.711-.082a78.742,78.742,0,0,1,.112-14.813,5.894,5.894,0,0,1,1.3-3.13A24.736,24.736,0,0,0,116.3,360.24Z",
    transform: "translate(-91.042 -338.622)",
    fill: "#efceb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9765",
    "data-name": "Path 9765",
    d: "M127.05,345.278s-10.178,3.777-12.839,12.087a22.168,22.168,0,0,0-.221,12.153,4.176,4.176,0,0,1,0,2.071,93.249,93.249,0,0,0-2.421,19.593h.81a92.613,92.613,0,0,1,2.34-19.171,7.188,7.188,0,0,1,1.207-2.577,64.969,64.969,0,0,0,6.4-10.255A110,110,0,0,0,127.05,345.278Z",
    transform: "translate(-92.194 -338.376)",
    fill: "#ffefe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9766",
    "data-name": "Path 9766",
    d: "M93.647,384.952a28.228,28.228,0,0,0-2.35-9.237,3.154,3.154,0,0,1-.237-1.671,15.271,15.271,0,0,0-.238-4.967C90,365,84.584,356.191,76.749,355.675a57.01,57.01,0,0,1,4.095,7.983c1.76,4.6,4.273,9.413,8.438,11.26a3.131,3.131,0,0,1,1.612,1.674A27.307,27.307,0,0,1,92.933,385Z",
    transform: "translate(-76.749 -342.989)",
    fill: "#ebcbb0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12371",
    "data-name": "Group 12371",
    transform: "translate(8.226 37.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12370",
    "data-name": "Group 12370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9767",
    "data-name": "Path 9767",
    d: "M94.908,422.638h12.93l3.355-20.5a1.491,1.491,0,0,0-1.472-1.732h-16.7a1.491,1.491,0,0,0-1.471,1.732Z",
    transform: "translate(-91.533 -400.406)",
    fill: "#f6e6d9"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    x2: 361.781,
    transform: "translate(49.89 276.651)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.114
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldOn);
export default __webpack_public_path__ + "static/media/hold-on.79116d8eb10f01119fa3a4b65f4747be.svg";
export { ForwardRef as ReactComponent };